type Props = {
  size?: number;
};

const XIcon = ({ size = 32 }: Props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="black" />
      <g transform="translate(12,12) scale(0.6) translate(-12,-12)">
        <path
          d="M18.244 2H21l-6.56 7.5L22 22h-6.828l-5.35-7.01L3.7 22H1l7.03-8.03L2 2h6.97l4.84 6.36L18.244 2z"
          fill="none"
          stroke="white"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default XIcon;